module.exports = __webpack_public_path__ + "static/media/login-app-teaser-bmw-v2.88c2d152.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/login-app-teaser-bmw-v2.png
// module id = 1722
// module chunks = 0